export default "__VITE_ASSET__BOGk6H6u__"